import { render, staticRenderFns } from "./RemoveInviteModal.vue?vue&type=template&id=2ada4140&lang=pug"
import script from "./RemoveInviteModal.vue?vue&type=script&lang=js"
export * from "./RemoveInviteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports